
import Vue from 'vue';
import ABaseComponent from 'Components/Base/ABaseComponent';
import Component from 'vue-class-component';
import { ScannedBarcodeState } from 'Api/CoreApi';
import { BarcodeConfirmItemReceivedComponent } from './BarcodeConfirmItemReceivedComponent';
import { BarcodeTakeItemOutOfCirculationComponent } from './BarcodeTakeItemOutOfCirculationComponent';
import { BarcodeChangePorterComponent } from './BarcodeChangePorterComponent';
import { filter } from 'lodash-es';
import ABarcodeActionsComponent from './ABarcodeActionsComponent';
import barcodestore from 'Store/barcode/barcodestore';

@Component({
    components:{
        BarcodeConfirmItemReceivedComponent,
        BarcodeTakeItemOutOfCirculationComponent,
        BarcodeChangePorterComponent
    }
})
export class BarcodeSelectorComponent extends ABaseComponent {
    
    public selectedState: string = ScannedBarcodeState.CUSEX;
    public availableStates: string[] = null; 
    
    
    async created() {
        this.availableStates = Object.keys(ScannedBarcodeState).map(key => key)
        .filter((x: any) => x != ScannedBarcodeState.None);
        
        
        const self = this;
        // setTimeout(async () => {
        //     const isLoaded = await self.checkIfDynamicComponentIsLoadedAsync();
        //     if(isLoaded) self.setLoaded();
        // },2);

        self.setLoaded();
    }
    
    
    updateState(event: any, action: string){
        console.log("Changed state to: " , action);
        
        this.setLoading();
        this.selectedState = action;
        barcodestore.clearList();
        barcodestore.add();
        const self = this;
        
        this.$nextTick(async () => {
            const isLoaded = await self.checkIfDynamicComponentIsLoadedAsync();
            if(isLoaded) self.setLoaded();
        });
    }
    
    checkIfDynamicComponentIsLoadedAsync(): boolean{
       return true;
        let checkIfDynamicComponentIsLoadedIntervalId: number = null;
        let checkIfDynamicComponentIsLoadedIntervalRetry = 0;

      
    }
    

 
    checkIfDynamicComponentIsLoaded(){
        const component = <ABaseComponent>this.$refs.component;
        return !component.loading;
    }
    
    
    get selectedComponentByState(){
        switch(this.selectedState){
            case ScannedBarcodeState.CUSEX:
            case ScannedBarcodeState.CUSIN:
            return BarcodeConfirmItemReceivedComponent.name.replace('component','');
            
            case ScannedBarcodeState.AFKEUR:
            return BarcodeTakeItemOutOfCirculationComponent.name.replace('component','');
            
            case ScannedBarcodeState.CUSCHP:
            return BarcodeChangePorterComponent.name.replace('component','');
            
            
            default:
            return;
        }
        
        
    }
    
    
}
Vue.component('barcode-selector', BarcodeSelectorComponent);